import { Component, inject, OnInit, signal } from '@angular/core';
import { NgxButtonComponent } from '@digipay/ngx-button';
import { WealthNavigationService } from '@client-monorepo/wealth/navigation';
import {
  CAMPAIGN_OTP_ROUTE,
  CONFIRM_COLLATERAL_INFO_ROUTE,
  HOME_ROUTE,
  SEJAM_ERROR_ROUTE,
  TREASURE_HUNT_NATIONAL_ID_ROUTE,
} from '../../data-access/constants/app-routes';
import { NgxCalloutComponent } from '@digipay/ngx-callout';
import { CollateralService } from './services/collateral.service';
import { IProcessData } from './models/process-data.interface';
import { ActivatedRoute } from '@angular/router';
import { RouteStateService } from '@client-monorepo/common/utilities';
import { ECollateralPage } from './models/collatetral-page.enum';
import { NgxAppBarComponent } from '@digipay/ngx-app-bar';

@Component({
  selector: 'wealth-applet-collateral',
  standalone: true,
  imports: [NgxButtonComponent, NgxAppBarComponent, NgxCalloutComponent],
  templateUrl: './collateral.component.html',
  styleUrl: './collateral.component.scss',
})
export class CollateralComponent implements OnInit {
  isLoading = false;

  stepItems: string[] = [];
  calloutMessages: string[] = [];

  symbol = signal<string>('');

  state: {
    symbol: string;
    coordinatorAction: string;
  };
  private routeState = inject(RouteStateService);
  private activatedRoute = inject(ActivatedRoute);
  private collateralService = inject(CollateralService);
  private navigationService = inject(WealthNavigationService);

  ngOnInit(): void {
    this.state = this.routeState.getAll();
    this.symbol.set(this.activatedRoute.snapshot.params?.['symbol']);
    this.stepItems = [
      'توثیق دارایی به معنای استفاده از دارایی های موجود شما به عنوان ضمانت برای دریافت اعتبار است؛ به این صورت که دارایی شما در صندوق ارزش آفرین گلرنگ به عنوان وثیقه قرار گرفته و تا سقف 80 درصد ارزش اسمی واحدها به شما اعتبار 4 قسطه تعلق می گیرد.',
      ' در صورتی که دارایی شما در صندوق قبلاً وثیقه شده باشد یا دارایی کافی به میزان مبلغ وثیقه موجود نباشد، اعتبار تخصیص داده نمی شود.',
      ' در صورت عدم پرداخت اقساط در موعد مقرر، دارایی وثیقه شده به نفع دیجی پی ابطال خواهد شد.',
      ' ثبت وثیقه به معنای تخصیص قطعی اعتبار نیست؛ اعتبار تنها پس از ثبت موفقیت آمیز وثیقه و بر اساس شرایط تعیین شده تخصیص می یابد.',
      ' رفع توثیق پس از تسویه کلیه بدهی ها و به درخواست کاربر انجام خواهد شد.',
    ];

    this.calloutMessages = [
      'تا سقف ۵۰ میلیون تومان، اعتبار ۴ قسطه دریافت خواهید کرد.',
      'نداشتن اعتبار ۴ قسطه فعال و یا اقساط معوق از شروط دریافت اعتبار است.',
    ];
  }

  continue() {
    this.isLoading = true;
    const data: IProcessData = {
      instrumentSymbol: this.symbol(),
    };
    this.collateralService.process(data, this.state.coordinatorAction).subscribe((res) => {
      if (res?.success) {
        switch (res.result.data.pageName) {
          case ECollateralPage.page_global_national_id:
            this.navigationService.navigate([TREASURE_HUNT_NATIONAL_ID_ROUTE], {
              state: {
                symbol: this.symbol(),
                phoneNumber: res?.result?.data?.phoneNumber,
                coordinatorAction: res?.result?.data?.coordinatorAction,
                nationalId: res?.result?.data?.nationalId,
                maxAmount: res?.result?.data?.maxAmount,
                minAmount: res?.result?.data?.minAmount,
                data: res?.result?.data,
              },
            });
            break;
          case ECollateralPage.page_collateral_form_confirm:
            this.navigationService.navigateWithState([CONFIRM_COLLATERAL_INFO_ROUTE], {
              state: {
                nationalId: res?.result?.data?.nationalId,
                maxAmount: res?.result?.data?.maxAmount,
                minAmount: res?.result?.data?.minAmount,
                coordinatorAction: res?.result?.data?.coordinatorAction,
                symbol: this.symbol(),
                data: res?.result?.data,
              },
            });
            break;
          case ECollateralPage.page_global_sejami_exception:
            this.navigationService.navigate([SEJAM_ERROR_ROUTE]);
            break;
          case ECollateralPage.page_global_otp:
            this.navigationService.navigateWithState([CAMPAIGN_OTP_ROUTE], {
              state: {
                nationalId: res?.result?.data?.nationalId,
                maxAmount: res?.result?.data?.maxAmount,
                minAmount: res?.result?.data?.minAmount,
                countDown: res?.result?.data?.countdownInSeconds,
                coordinatorAction: res?.result?.data?.coordinatorAction,
                data: data,
                symbol: this.symbol(),
              },
            });
            break;
        }
      }
      this.isLoading = false;
    });
  }

  onBackHandler() {
    this.navigationService.navigate([HOME_ROUTE]);
  }
}
